module.exports = "<div class=\"well well-sm\">\n\t<legend> Turno reagendado </legend>\n\t<div class=\"col-xs-12\">\n\t\t<div class=\"col-xs-9\">\n\t\t\t{{$ctrl.turnoDetalle.Mensaje_Reagendado}}\n\t\t</div>\n\t\t<button class=\"pull-right btn btn-info btn-md col-xs-3\" ng-click=\"$ctrl.mostrarOtroTurno()\">\n\t\t\t<i class=\"fa fa-arrow-right\" aria-hidden=\"true\"></i> Click para ver el turno\n\t\t</button>\n\t</div>\n\t<div class=\"clearfix\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./app/components/turnos/turnoReagendado.html
// module id = 456
// module chunks = 0